import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b2bc27ee&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b2bc27ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc27ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bc27ee')) {
      api.createRecord('b2bc27ee', component.options)
    } else {
      api.reload('b2bc27ee', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b2bc27ee&scoped=true&", function () {
      api.rerender('b2bc27ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UEZMrfcYmVYA/JS/comp/Voucher.vue"
export default component.exports